angular.module("app").controller("PagesListPageController", [
    '$scope',
    'preloadedPages',
    '$state',
    'pagesService',
    'errorHandler',
    'logger',
    'settingsService',
    '$timeout',
    'typeToLoad',
    'pageStatuses',
    'userStorage',
    'pageTypes',
    '$cookies',
    'pagination',
    function ($scope, preloadedPages, $state, pagesService, errorHandler, logger, settingsService, $timeout, typeToLoad, pageStatuses, userStorage, pageTypes, $cookies, pagination) {

        var settings = settingsService.getSettings(),
            pendingListRequest;

        $scope.userData = userStorage.getUserData();
        $scope.pageTypes = pageTypes;
        $scope.pagination = pagination.init(function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                $scope.updateList($scope.selectedLanguage, {
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            }, 300);
        }, preloadedPages.total_count);
        $scope.state = $state;
        $scope.pageStatuses = pageStatuses;
        $scope.filterOptions = {
            status: $scope.pageStatuses[0]
        };
        $scope.pages = preloadedPages.pages;
        $scope.languages = settings.skin.languages;
        $scope.selectedLanguage = $cookies.get("preferedLanguage") || settings.skin.defaultLang;

        $scope.editPage = function (page, showMain, hasItems) {
            if (!showMain) {
                return $state.go("main.pages.editDetailed", {
                    pageId: page.id,
                    showMain: !!showMain,
                    hasItems: !!hasItems
                });
            }
            $state.go("main.pages.edit", {pageId: page.id, showMain: !!showMain, hasItems: !!hasItems});
        };

        $scope.updateList = function (language, externalOptions) {
            var requestObject = {
                lang: language,
                type: typeToLoad,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status
            };
            $cookies.put("preferedLanguage", language);
            if (!!externalOptions) {
                angular.extend(requestObject, externalOptions)
            }
            pagesService.getPages(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.pages = angular.copy(response.pages)
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.deletePage = function (page) {
            if (!$scope.checkUserRole()) {
                return
            }
            pagesService.deletePage(page.id).then(
                function (response) {
                    if (response.status == "ok") {
                        spliceFromList(page);
                        logger.logSuccess("global.successfullyDeleted");
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        $scope.getDateTime = function (dateString) {
            return new Date(dateString).getTime()
        };

        $scope.publishPage = function (page) {
            if (!$scope.checkUserRole()) {
                return
            }
            pagesService.publishPage(page.id).then(
                function (response) {
                    if (response.status == "ok") {
                        spliceFromList(page);
                        logger.logSuccess("global.successfullyPublished");
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        $scope.checkUserRole = function () {
            return $scope.userData.role !== 'skin_news_manager'
        };

        function spliceFromList(page) {
            var index = $scope.pages.indexOf(page);
            if (index != -1) {
                $scope.pages.splice(index, 1);
            }
        }
    }
]);